/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CSSTransitionGroup from 'preact-css-transition-group';

import ButtonResumeTs from '../ButtonResumeTs';
import BtnClose from '../BtnClose';
import BtnMinimize from '../BtnMinimize';

import aniIconBotGreen from '../../images/waiting-green.gif';
import aniIconBotWhite from '../../images/waiting-white.gif';

import styles from './index.scss';

import { BTS_EXPANDED, BTS_TROUBLESHOOTING, BTS_LIVE_AGENT_CHAT } from '../../consts';

const JoButtonGray = ({
    buttonState,
    isRunningChat,
    isMobile,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleCloseFromChatState,
    handleCloseClick,
    autoExpand,
}) => {
    const buttonWrapperClasses = classNames({
        [styles.joButtonWrapper]: true,
    });
    const chatButtonClasses = classNames({
        [styles.joButton]: true,
        [styles.joButtonInChatState]: isRunningChat,
    });
    const helpPanelClasses = classNames({
        [styles.needHelpPanel]: true,
        [styles.expanded]: buttonState === BTS_EXPANDED,
    });

    const resumeTsPanelClasses = classNames({
        [styles.resumeTroubleshootingPanel]: true,
        [styles.expanded]: buttonState === BTS_TROUBLESHOOTING,
    });

    const chatState = buttonState === BTS_TROUBLESHOOTING || buttonState === BTS_LIVE_AGENT_CHAT;

    const resumeTsPanelClickHandle = isMobile ? handleClick : () => {};

    const mouseHandlers = isMobile
        ? {}
        : {
              onMouseEnter: handleMouseEnter,
              onMouseLeave: handleMouseLeave,
          };

    return (
        <div {...mouseHandlers} className={buttonWrapperClasses}>
            <CSSTransitionGroup component="div" transitionName="panel-anim">
                {buttonState === BTS_EXPANDED ? (
                    <div onClick={handleClick} className={helpPanelClasses}>
                        <div className={styles.needHelpPanelInnerWrap}>
                            <span>
                                Need help with your{' '}
                                <strong className={styles.productName}>Back-UPS</strong>?
                            </span>
                            {autoExpand ? <BtnMinimize onClick={handleCloseClick} /> : null}
                        </div>
                    </div>
                ) : null}
            </CSSTransitionGroup>
            <button onClick={handleClick} className={chatButtonClasses} aria-label="">
                {chatState ? (
                    <img className={styles.botIcon} src={aniIconBotGreen} />
                ) : (
                    <img className={styles.botIcon} src={aniIconBotWhite} />
                )}
            </button>
            <CSSTransitionGroup component="div" transitionName="panel-anim">
                {chatState ? (
                    <div onClick={resumeTsPanelClickHandle} className={resumeTsPanelClasses}>
                        <div className={styles.resumeTroubleshootingPanelInnerWrap}>
                            {isMobile ? (
                                <span>Resume Troubleshooting</span>
                            ) : (
                                <ButtonResumeTs
                                    className={styles.btnResumeTroubleshooting}
                                    onClick={handleClick}
                                >
                                    Resume Troubleshooting
                                </ButtonResumeTs>
                            )}
                            <BtnClose onClick={handleCloseFromChatState} />
                        </div>
                    </div>
                ) : null}
            </CSSTransitionGroup>
        </div>
    );
};

JoButtonGray.propTypes = {
    buttonState: PropTypes.string,
    isRunningChat: PropTypes.bool,
    isMobile: PropTypes.bool,
    handleClick: PropTypes.func,
    handleMouseEnter: PropTypes.func,
    handleMouseLeave: PropTypes.func,
    handleCloseFromChatState: PropTypes.func,
    handleCloseClick: PropTypes.func,
    autoExpand: PropTypes.bool,
    // fill: PropTypes.string,
    // className: PropTypes.string,
    // width: PropTypes.number,
    // height: PropTypes.number,
};

JoButtonGray.defaultProps = {
    // fill: '#3dcd58',
    // className: '',
    // width: 35,
    // height: 35,
};

export default JoButtonGray;
